"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BookingItemEditor = void 0;
const cloneDeep_1 = __importDefault(require("lodash/cloneDeep"));
const react_1 = __importStar(require("react"));
const Card_1 = __importDefault(require("react-bootstrap/Card"));
const react_dnd_1 = require("react-dnd");
const react_dnd_html5_backend_1 = require("react-dnd-html5-backend");
const react_table_1 = require("react-table");
const IconDragIndicator_1 = require("../icons/IconDragIndicator");
const ResourceIconWithColor_1 = require("../resource-icon-with-color/ResourceIconWithColor");
require("./BookingItemEditor.scss");
const BookingItemTableFooter_1 = require("./BookingItemTableFooter");
const ItemActionCell_1 = require("./cell-renderer/ItemActionCell");
const ItemPriceCell_1 = require("./cell-renderer/ItemPriceCell");
const ItemQuantityCell_1 = require("./cell-renderer/ItemQuantityCell");
const ItemTitleCell_1 = require("./cell-renderer/ItemTitleCell");
const ItemTypeCell_1 = require("./cell-renderer/ItemTypeCell");
const ItemUnitCell_1 = require("./cell-renderer/ItemUnitCell");
const BookingItemEditor = (props) => {
    var _a;
    const columns = (0, react_1.useMemo)(() => {
        return [
            {
                id: "Artikel",
                Header: () => react_1.default.createElement("span", { style: { marginLeft: "-25px" } }, "Artikel"),
                width: "99%",
                Cell: (cellProps) => (react_1.default.createElement(ItemTitleCell_1.ItemTitleCell, { booking: props.booking, onBookingChange: props.onBookingChange, item: cellProps.row.original, onItemChange: props.onBookingItemChange, isResource: cellProps.row.index === 0, editable: props.editable })),
            },
            {
                Header: "Kategorie",
                minWidth: 136,
                Cell: (cellProps) => (react_1.default.createElement(ItemTypeCell_1.ItemTypeCell, { booking: props.booking, item: cellProps.row.original, onItemChange: props.onBookingItemChange, isResource: cellProps.row.index === 0, allTypes: props.booking.configResource
                        ? props.booking.configResource.getAddonTypes({
                            includeHidden: true,
                            includeMisc: true,
                        })
                        : [], editable: props.editable })),
            },
            {
                id: "Menge",
                Header: () => react_1.default.createElement("div", { style: { textAlign: "right" } }, "Menge"),
                minWidth: 64,
                Cell: (cellProps) => (react_1.default.createElement(ItemQuantityCell_1.ItemQuantityCell, { item: cellProps.row.original, onItemChange: props.onBookingItemChange, isResource: cellProps.row.index === 0, editable: props.editable })),
            },
            {
                Header: "Einheit",
                minWidth: 130,
                Cell: (cellProps) => (react_1.default.createElement(ItemUnitCell_1.ItemUnitCell, { item: cellProps.row.original, onItemChange: props.onBookingItemChange, isResource: cellProps.row.index === 0, editable: props.editable })),
            },
            {
                id: "Preis in CHF",
                Header: () => react_1.default.createElement("div", { style: { textAlign: "right" } }, "Preis in CHF"),
                minWidth: 130,
                Cell: (cellProps) => (react_1.default.createElement(ItemPriceCell_1.ItemPriceCell, { item: cellProps.row.original, onItemChange: props.onBookingItemChange, editable: props.editable })),
            },
            {
                id: "Action",
                Header: "",
                Cell: (cellProps) => (react_1.default.createElement(ItemActionCell_1.ItemActionCell, { item: cellProps.row.original, onItemDelete: () => props.onBookingItemChange(cellProps.row.original, true), isResource: cellProps.row.index === 0, editable: props.editable })),
            },
        ];
    }, [
        props.booking.id,
        props.booking.start,
        props.booking.end,
        // Rerender if addon items are added or deleted.
        // Note: If rerendering is done when an item is edited, the input fields loose focus.
        props.booking.addonItems.length,
        // Update when user switches to another resource.
        props.booking.resourceItem.type,
        props.booking.resourceItem.title,
    ]);
    const items = (0, react_1.useMemo)(() => {
        // Returns all items with the resource first and then all addon items.
        return [props.booking.resourceItem, ...props.booking.addonItems];
    }, [
        // Update when items change.
        props.booking.resourceItem,
        props.booking.addonItems,
    ]);
    // Init table.
    const { getTableProps, getTableBodyProps, headerGroups, prepareRow, rows } = (0, react_table_1.useTable)({
        columns,
        data: items,
        getRowId: (row) => {
            return row.key;
        },
    });
    function updateBooking(newItems) {
        const [resourceItem, ...addonItems] = newItems;
        props.onBookingChange({ resourceItem, addonItems });
    }
    function handleMoveRow(dragIndex, hoverIndex) {
        const dragRecord = (0, cloneDeep_1.default)(items[dragIndex]);
        let newItems = Object.assign(new Array(), items);
        newItems.splice(dragIndex, 1);
        newItems.splice(hoverIndex, 0, dragRecord);
        updateBooking(newItems);
    }
    function handleAddRow(newItem) {
        const newItems = [...items, newItem];
        updateBooking(newItems);
    }
    return (react_1.default.createElement(Card_1.default, { className: "booking-item-table-card " + ((_a = props.className) !== null && _a !== void 0 ? _a : "") },
        react_1.default.createElement(Card_1.default.Body, { className: "px-0 py-0" },
            react_1.default.createElement(react_dnd_1.DndProvider, { backend: react_dnd_html5_backend_1.HTML5Backend },
                react_1.default.createElement("table", { ...getTableProps(), className: "item-table" },
                    react_1.default.createElement("thead", null, headerGroups.map((headerGroup) => (react_1.default.createElement("tr", { ...headerGroup.getHeaderGroupProps() },
                        react_1.default.createElement("th", null),
                        headerGroup.headers.map((column) => (react_1.default.createElement("th", { ...column.getHeaderProps(), style: {
                                width: column.width,
                                minWidth: column.minWidth,
                                whiteSpace: "nowrap",
                            } }, column.render("Header")))))))),
                    react_1.default.createElement("tbody", { ...getTableBodyProps() }, rows.map((row, index) => {
                        var _a;
                        prepareRow(row);
                        if (index === 0) {
                            return (react_1.default.createElement("tr", { key: "resourceItem" },
                                react_1.default.createElement("td", null,
                                    react_1.default.createElement(ResourceIconWithColor_1.ResourceIconWithColor, { resource: (_a = props.booking.configResource) !== null && _a !== void 0 ? _a : props.booking.getResourceId(), noTitle: true })),
                                row.cells.map((cell) => {
                                    return (react_1.default.createElement("td", { ...cell.getCellProps() }, cell.render("Cell")));
                                })));
                        }
                        else {
                            return (react_1.default.createElement(DraggableRow, { index: index, row: row, onMoveRow: handleMoveRow, ...row.getRowProps() }));
                        }
                    }))))),
        react_1.default.createElement(BookingItemTableFooter_1.BookingItemTableFooter, { booking: props.booking, onBookingChange: props.onBookingChange, onNewAddon: handleAddRow, editable: props.editable })));
};
exports.BookingItemEditor = BookingItemEditor;
const DND_ITEM_TYPE = "dnd_row";
const DraggableRow = ({ row, index, onMoveRow }) => {
    const dropRef = (0, react_1.useRef)(null);
    const dragRef = (0, react_1.useRef)(null);
    const [, drop] = (0, react_dnd_1.useDrop)({
        accept: DND_ITEM_TYPE,
        hover(item, monitor) {
            var _a;
            if (!dropRef.current) {
                return;
            }
            // @ts-ignore
            const dragIndex = item.index;
            const hoverIndex = index;
            // Don't replace items with themselves
            if (dragIndex === hoverIndex) {
                return;
            }
            // Determine rectangle on screen
            const hoverBoundingRect = (_a = dropRef.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect();
            // Get vertical middle
            const hoverMiddleY = (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2;
            // Determine mouse position
            const clientOffset = monitor.getClientOffset();
            // Get pixels to the top
            const hoverClientY = clientOffset.y - hoverBoundingRect.top;
            // Only perform the move when the mouse has crossed half of the items height
            // When dragging downwards, only move when the cursor is below 50%
            // When dragging upwards, only move when the cursor is above 50%
            // Dragging downwards
            if (dragIndex < hoverIndex && hoverClientY < hoverMiddleY) {
                return;
            }
            // Dragging upwards
            if (dragIndex > hoverIndex && hoverClientY > hoverMiddleY) {
                return;
            }
            // Time to actually perform the action
            onMoveRow(dragIndex, hoverIndex);
            // Note: we're mutating the monitor item here!
            // Generally it's better to avoid mutations,
            // but it's good here for the sake of performance
            // to avoid expensive index searches.
            // @ts-ignore
            item.index = hoverIndex;
        },
    });
    const [{ isDragging }, drag, preview] = (0, react_dnd_1.useDrag)(() => ({
        type: DND_ITEM_TYPE,
        item: { index },
        collect: (monitor) => ({
            isDragging: monitor.isDragging(),
        }),
    }));
    const opacity = isDragging ? 0 : 1;
    preview(drop(dropRef));
    drag(dragRef);
    return (react_1.default.createElement("tr", { ref: dropRef, style: { opacity } },
        react_1.default.createElement("td", { ref: dragRef, className: "reorder-handle" },
            react_1.default.createElement(IconDragIndicator_1.IconDragIndicator, null)),
        row.cells.map((cell) => {
            return react_1.default.createElement("td", { ...cell.getCellProps() }, cell.render("Cell"));
        })));
};
